import React, { FC, PropsWithChildren } from 'react';

import styles from './BlurBackgroundBlock.module.scss';

type Props = {
	anchorId: string;
};

export const BlurBackgroundBlock: FC<Props & PropsWithChildren> = ({ anchorId, children }) => {
	const handleClickOnBlurCard = () => {
		const element = document.getElementById(anchorId);

		element.scrollIntoView({
			behavior: 'smooth',
			block: 'center',
		});
	};

	return (
		<div onClick={handleClickOnBlurCard}>
			<div className={styles.disableBlockWrapper} />
			<div className={styles.disableBlockContent}>{children}</div>
		</div>
	);
};
